import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    appDrawerSelector,
    handleLeftAppDrawerState,
    setAppDrawerState,
    setIsLoading,
    setIsRightDrawerPinned,
    setRightDrawerState,
} from 'store/themeSettings';
import {DrawerTypeValue} from 'types';

export const useAppDrawerInRedux = () => {
    const dispatch = useDispatch();
    const {
        isLeftDrawerOpened: isDrawerOpenedInRedux,
        isLoading: isLoadingInRedux,
        isRightDrawerOpened: isRightDrawerOpenedInRedux,
    } = useSelector(appDrawerSelector);

    const isDrawerOpened = useMemo(() => {
        return isDrawerOpenedInRedux;
    }, [isDrawerOpenedInRedux]);

    const isRightDrawerOpened = useMemo(() => {
        return isRightDrawerOpenedInRedux;
    }, [isRightDrawerOpenedInRedux]);

    const isLoading = useMemo(() => {
        return isLoadingInRedux;
    }, [isLoadingInRedux]);

    const setIsAppDrawerOpenInRedux = useCallback(() => {
        dispatch(handleLeftAppDrawerState());
    }, [dispatch]);

    const setAppDrawerStateInRedux = useCallback(
        (value: boolean) => {
            dispatch(setAppDrawerState(value));
        },
        [dispatch],
    );

    const setIsRightDrawerOpenInRedux = useCallback(
        (value: DrawerTypeValue | null) => {
            dispatch(setRightDrawerState(value));
        },
        [dispatch],
    );

    const setIsRightDrawerPinnedInRedux = useCallback(
        (value: boolean) => {
            dispatch(setIsRightDrawerPinned(value));
        },
        [dispatch],
    );

    const setIsLoadingInRedux = useCallback(
        (value: boolean) => {
            dispatch(setIsLoading(value));
        },
        [dispatch],
    );

    return {
        isDrawerOpened,
        isLoading,
        setIsLoadingInRedux,
        isRightDrawerOpened,
        setIsRightDrawerPinnedInRedux,
        setIsRightDrawerOpenInRedux,
        setIsAppDrawerOpenInRedux,
        setAppDrawerStateInRedux,
    };
};
